// @ts-nocheck
import dompurify from 'dompurify';
import { getObjLength } from './ObjectHelper';
import htmlToFormattedText from 'html-to-formatted-text';
import moment from 'moment';
import { Option, StatusStyling } from '@src/interfaces/type';
import { emailPattern, indianNumberRegex } from './Regex';
import { RESTAURANT } from '@src/Constants';

export const isString = (anyVar) => {
	return typeof anyVar === 'string';
};

export const isEmptyString = (str) => {
	return !str || str.length === 0;
};

export const translateHTMLInputToText = (html) => {
	let result;
	const reg = new RegExp('<img\\s[^>]*?src\\s*=\\s*[\'\\"]([^\'\\"]*?)[\'\\"][^>]*?>', 'g');
	result = html.replace(reg, function (occurrences) {
		// Extract unicode from aria-label
		const matches = occurrences.match(new RegExp('aria-label="\\s*(.*?)\\s*,'), '$1');
		if (matches && matches.length >= 1) {
			return matches[1];
		}
		return '';
	});

	// Convert it to plain text
	result = htmlToFormattedText(result);

	return result;
};

export const generateInitialsHelper = (name) => {
	return (name ? name.replace(/[^a-z\d\s]+/gi, '').trim()[0] : '')?.toUpperCase();
};

export const generateUnixTimestamp = () => {
	return Math.round(+new Date() / 1000);
};

export const stringContainsAnyInArray = (string, array) => {
	for (let i = 0; i < array.length; i++) {
		if (string.includes(array[i])) {
			return true;
		}
	}

	return false;
};

export const getSelectionHtml = () => {
	let html = '';
	if (typeof window.getSelection != 'undefined') {
		const sel = window.getSelection();
		if (sel.rangeCount) {
			const container = document.createElement('div');
			for (let i = 0, len = sel.rangeCount; i < len; ++i) {
				container.appendChild(sel.getRangeAt(i).cloneContents());
			}
			html = container.innerHTML;
		}
	} else if (typeof document.selection != 'undefined') {
		if (document.selection.type === 'Text') {
			html = document.selection.createRange().htmlText;
		}
	}
	return html;
};

export const displaySeconds = (seconds) => {
	const format = (val) => `0${Math.floor(val)}`.slice(-2);
	//const hours = seconds / 3600;
	const minutes = (seconds % 3600) / 60;

	return [minutes, seconds % 60].map(format).join(':');
};

export const containsLetters = (text) => {
	const regExp = /[a-zA-Z]/g;
	return regExp.test(text);
};

export const extractAvatarFromContactProviderData = (
	contactProviderData: any,
	isLarge?: boolean
) => {
	if (contactProviderData) {
		for (let i = 0; i < getObjLength(contactProviderData); i++) {
			const data = contactProviderData[i];
			if (data?.avatar) {
				return isLarge === true && data?.large_avatar ? data.large_avatar : data.avatar;
			}
		}
	}

	return undefined;
};

export const hasInternetConnection = () => {
	return navigator.onLine;
};

export const sortMessagesAsc = (messages) => {
	let sortedNextState = Object.entries(messages).sort((a, b) => a[1].timestamp - b[1].timestamp);
	return Object.fromEntries(sortedNextState);
};

export const isScrollable = (el) => {
	const hasScrollableContent = el.scrollHeight > el.clientHeight;
	const overflowYStyle = window.getComputedStyle(el).overflowY;
	const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

	return hasScrollableContent && !isOverflowHidden;
};

export const sanitize = (dirty) => {
	if (!dirty) return;
	const sanitizer = dompurify.sanitize;
	return sanitizer(dirty);
};

export const generateUniqueID = () => {
	return `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

export const debounce = (fn, delay) => {
	let timer = null;
	return function (...args) {
		const context = this;
		timer && clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(context, args);
		}, delay);
	};
};

export const generateErrorMessage = (msg: string) => {
	if (msg?.split(' ')?.slice(1)?.join(' ') === 'should not be empty') {
		return "Label can't be empty";
	}
	return msg;
};

export const replaceIfOnlyNewlines = (input) => {
	const regex = /^(\n)+$/g;
	if (regex.test(input)) {
		return input.replace(/\n/g, '');
	}
	return input;
};

export const isDocumentFile = (file) => {
	if (file) {
		const fileExtension = file.name.split('.').pop().toLowerCase();
		const documentFormats = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'];
		const imageFormats = ['jpg', 'jpeg', 'png', 'gif'];

		return documentFormats.includes(fileExtension) || imageFormats.includes(fileExtension);
	}

	return false;
};

export const omitPlusFromNumber = (number) => {
	if (typeof number === 'string' && number.length > 0 && number[0] === '+') {
		return number.slice(1);
	}
	return number;
};

export const extractNumbersWithPlus = (inputStr) => {
	let extracted = '';
	let plusFound = false;

	for (let i = 0; i < inputStr.length; i++) {
		const char = inputStr[i];

		if (!isNaN(char) || char === '+' || char === ' ') {
			if (char === '+') {
				if (plusFound) {
					// Skip adding consecutive '+' signs
					continue;
				} else {
					plusFound = true;
				}
			}

			if (char !== ' ') {
				extracted += char;
			}
		}
	}

	return extracted;
};

export const hasExpired = (timestamp) => {
	const currentTimestamp = new Date().getTime();
	return timestamp < currentTimestamp;
};

export const validPhoneNumber = (number: string) => {
	if (number?.length >= 8) {
		for (let i = 0; i < number.length; i++) {
			if (isNaN(number[i])) {
				return false;
			}
		}
		return true;
	} else {
		return false;
	}
};

export const getBaseRoute = (type) => {
	if (type?.toLowerCase() === RESTAURANT) {
		return 'restaurants';
	}
	return 'suppliers';
};

export const truncateField = (field: string, characterLength?: number = 32): string => {
	const truncatedFieldValue: string =
		field?.length > characterLength ? field?.substring(0, characterLength) + '...' : field;
	return truncatedFieldValue;
};

export const formatPriceValue = (value) => {
	if (value === '0') {
		return 0;
	}
	const floatValue = parseFloat(value);
	if (!isNaN(floatValue)) {
		const truncatedValue = Math.floor(floatValue * 100) / 100;
		return truncatedValue.toFixed(2);
	}
	return value;
};

export const setOrderStatus = (status: string) => {
	const statusArray = [
		'submitted',
		'awaiting payment',
		'awaiting customer confirmation',
		'edited, waiting confirmation',
		'confirmed by supplier',
		'processing',
		'multiple shipments',
		'ready to ship',
		'shipped',
		'in transit',
		'awaiting pickup',
		'delivered',
		'closed',
		'refunded',
		'rejected',
	];
	if (statusArray?.includes(status?.toLowerCase())) {
		return status;
	}
	return 'Confirmed';
};

export const editOrderPermission = (status) => {
	if (
		[
			'submitted',
			'awaiting payment',
			'awaiting customer confirmation',
			'edited, waiting confirmation',
		]?.includes(status?.toLowerCase())
	) {
		return false;
	}
	return true;
};

// Example usage
//const timestamp = '2023-09-14 12:31:37';
export const getElapsedTimeString = (timestamp: string): string => {
	const providedTimestamp = moment(timestamp, 'MMM DD, YYYY HH:mm:ss');
	const currentTime = moment();

	const duration = moment.duration(currentTime.diff(providedTimestamp));
	const seconds = duration.asSeconds();
	const minutes = duration.asMinutes();
	const hours = duration.asHours();
	const days = duration.asDays();

	if (seconds < 60) {
		return Math.floor(seconds) + ' second' + (Math.floor(seconds) === 1 ? '' : 's') + ' ago';
	} else if (minutes < 60) {
		return Math.floor(minutes) + ' minute' + (Math.floor(minutes) === 1 ? '' : 's') + ' ago';
	} else if (hours < 24) {
		return Math.floor(hours) + ' hour' + (Math.floor(hours) === 1 ? '' : 's') + ' ago';
	} else {
		return Math.floor(days) + ' day' + (Math.floor(days) === 1 ? '' : 's') + ' ago';
	}
};

export function formatBytes(bytes: number, decimals?: number) {
	if (bytes === 0) return '0 Bytes';
	var k = 1024,
		dm = decimals || 2,
		sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
		i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const validateFileUpload = (allowedFormats: string[], fileName: string) => {
	let allowedExtensions = new Set(allowedFormats);
	let fileExtension = fileName.split('.').pop().toLowerCase();

	return allowedExtensions.has(fileExtension);
};

export const validateFileSize = (fileSize: number, maxSize = 50 * 1024 * 1024): boolean => {
	return fileSize <= maxSize;
};

export interface Pixels {
	height: number;
	width: number;
}
export const validateFilePixelsAndSize = async (
	file: File,
	pixels: Pixels = { height: 100, width: 100 },
	validFileFormats?: string[] = ['jpg', 'png', 'jpeg'],
	fileSizeLimit?: number = 2 * 1024 * 1024
) => {
	try {
		const validFormat = validateFileUpload(validFileFormats, file?.name);
		const validSize = validateFileSize(file.size, fileSizeLimit);
		if (validFormat && validSize) {
			//fileFormatCheck
			const reader = new FileReader();

			// Read the contents of the Image File.
			reader.readAsDataURL(file);

			// Promisify the onload event using a Promise.
			const loadImage = () => {
				return new Promise((resolve, reject) => {
					reader.onload = resolve;
					reader.onerror = reject;
				});
			};

			// Wait for the FileReader to load the image.
			await loadImage();

			// Initiate the JavaScript Image object.
			const image = new Image();

			// Set the Base64 string returned from FileReader as the image source.
			image.src = reader.result;

			// Validate the File Height and Width.
			const response = await new Promise((resolve) => {
				image.onload = function () {
					const height = this.height;
					const width = this.width;
					if (height <= pixels?.height && width <= pixels?.width) {
						// console.log('Uploaded image has valid Height and Width.');
						resolve(image.src);
					} else {
						// console.log('Height and Width must not exceed 600px.');
						resolve(false);
					}
				};
			});
			if (response) {
				return 'allowed';
			}
			return `pixelExceeds`;
		} else {
			if (!validFormat) {
				return 'notSupported';
			} else {
				return 'sizeExceeds';
			}
		}
	} catch (error) {
		console.error('An error occurred while loading the image:', error);
		return '';
	}
};

export const cleanObject = (myObj) => {
	const cleanObj = Object.keys(myObj)
		.filter(
			(key) =>
				myObj[key] !== '' &&
				myObj[key] !== null &&
				myObj[key] !== undefined &&
				myObj[key].length !== 0 &&
				JSON.stringify(myObj[key]) !== JSON.stringify({})
		)
		.reduce((obj, key) => {
			obj[key] = myObj[key];
			return obj;
		}, {});
	return cleanObj;
};

export const fileErrors = (filename, errorMsg) => {
	const truncateFilename = filename.length > 35 ? `${filename?.substring(0, 32)}...` : filename;
	const error = {
		pixelExceeds: `${truncateFilename} has too many pixels. Please choose a smaller image.`,
		notSupported: `${truncateFilename} is not a supported format. Please use JPG or PNG.`,
		sizeExceeds: `${truncateFilename} is too large. Please choose a smaller file.`,
	};
	return error[errorMsg];
};

export const getBaseUrl = (hostname) => {
	switch (hostname) {
		case 'd320ad107nabyb':
			return 'https://d11t6uwi6yangv.cloudfront.net/api/v1/';
		default:
			return 'https://djq76z1kkky80.cloudfront.net/api/v1/';
	}
};

export function parseDate(dateString) {
	const parsedDate = new Date(dateString);
	return isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export const getStatusStyles = (status: string): StatusStyling => {
	if (typeof status === 'string') {
		const lowerCaseStatus = status?.toLowerCase();
		const statusData: Record<string, StatusStyling> = {
			submitted: { color: '#1592A6', background: '#E8F6F8' },
			pending: { color: '#E6AE06', background: '#FFF3CC' },
			'awaiting payment': { color: '#E6AE06', background: '#FFF3CC' },
			'awaiting customer confirmation': { color: '#E6AE06', background: '#FFF3CC' },
			'edited, waiting confirmation': { color: '#E6AE06', background: '#FFF3CC' },
			'confirmed by supplier': { color: '#5E94FF', background: '#EBF1FF' },
			processing: { color: '#5E94FF', background: '#EBF1FF' },
			'multiple shipment': { color: '#5E94FF', background: '#EBF1FF' },
			'ready to ship': { color: '#5E94FF', background: '#EBF1FF' },
			shipped: { color: '#5E94FF', background: '#EBF1FF' },
			'in transit': { color: '#5E94FF', background: '#EBF1FF' },
			'awaiting pickup': { color: '#5E94FF', background: '#EBF1FF' },
			delivered: { color: '#24963E', background: '#EAF6EC' },
			closed: { color: '#24963E', background: '#EAF6EC' },
			refunded: { color: ' #F26184', background: '#FEF0F3' },
			rejected: { color: ' #F26184', background: '#FEF0F3' },
			confirmed: { color: '#24963E', background: '#EAF6EC' },
		};
		if (lowerCaseStatus in statusData) {
			return statusData?.[lowerCaseStatus];
		}
	}
	return { color: '', background: '' };
};

export const canEditOrder = (selectedOptionId: number) => {
	if (selectedOptionId < window?.config?.validationOrder) {
		return true;
	}
	return false;
};

export const deepEqual = (obj1, obj2) => {
	if (obj1 === obj2) return true;

	if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

	const keys1 = obj1 ? Object.keys(obj1) : [];
	const keys2 = obj2 ? Object.keys(obj2) : [];

	if (keys1.length !== keys2.length) return false;

	for (const key of keys1) {
		if (!keys2.includes(key)) return false;

		if (!deepEqual(obj1[key], obj2[key])) return false;
	}

	return true;
};

export function capitalizeFirstLetter(input: string): string {
	return input.charAt(0).toUpperCase() + input.slice(1);
}

export const validateEmail = (email: string) => {
	return emailPattern?.test(email);
};

export const validatePhoneNumber = (number: string) => {
	return number?.length === 10;
};

export function getUniqueObjectsByKey(array, key) {
	const uniqueKeys = Array.from(new Set(array.map((item) => item?.[key])));
	const uniqueObjects = uniqueKeys.map((id) => {
		return array.find((item) => item?.[key] === id);
	});
	return uniqueObjects?.map((item) => item?.categoryObject);
}

export const setQueryParamsValues = (valuesObject) => {
	const searchParams = new URLSearchParams();

	// Loop through the valuesObject and set each parameter and its value
	for (const key in valuesObject) {
		if (Object.prototype.hasOwnProperty.call(valuesObject, key)) {
			const value = valuesObject[key];
			if (value !== undefined && value !== null) {
				searchParams.set(key, value.toString());
			}
		}
	}

	// Set a default limit if it's not provided
	if (!valuesObject.hasOwnProperty('limit')) {
		searchParams.set('limit', '25');
	}

	// Update URL with new params values
	const newUrl = new URL(window.location.href);
	newUrl.search = searchParams.toString();
	window.history.replaceState({}, '', newUrl.toString());
};

export const arraysEqual = (arr1, arr2) => {
	if (arr1.length !== arr2.length) {
		return false;
	}
	for (let i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) {
			return false;
		}
	}
	return true;
};

export const toCapitalize = (value: string) => {
	return value?.[0]?.toUpperCase() + value?.slice(1).toLowerCase();
};

export function capitalizeTitle(input: string): string {
	return input
		?.split(' ')
		?.map((word) => {
			if (word.length === 1) {
				return word?.toUpperCase();
			} else {
				const firstLetter = word?.charAt(0)?.toUpperCase();
				const restOfWord = word?.slice(1)?.toLowerCase();
				return firstLetter + restOfWord;
			}
		})
		.join(' ');
}

export const updateUrlWithParam = (key: string, value: string) => {
	if (typeof window !== 'undefined') {
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set(key, value);

		const updatedUrl = `${window.location.origin}${
			window.location.pathname
		}?${queryParams.toString()}`;

		window.history.replaceState({}, '', updatedUrl);
	}
};

export const getQueryParamValue = (key: string): string | null => {
	if (typeof window !== 'undefined') {
		const queryParams = new URLSearchParams(window.location.search);
		return queryParams.get(key);
	}

	return null;
};

export const convertUTCDateIntoIndianTimezone = (date: Date) => {
	//Getting date in UTC, adding minutes according to indian timezone diff
	let d = new Date(date as Date);
	d.setMinutes(d.getMinutes() + 330);
	return d;
};

export const isValidPath = (type, path) => {
	if (type === RESTAURANT) {
		return path?.includes('/marketplace/storeFront');
	}
	return path?.includes('/orders/allOrders?orderId');
};

export function roundTo2Decimals(num: number) {
	return Math.round(num * 100) / 100;
}

export function roundToInt(num: number) {
	return Math.round(num || 0);
}
